var _defs, _rect, _circle, _rect2, _text, _text2, _rect3, _text3, _text4, _rect4, _text5, _text6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverDonationAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Donation tracking analytics",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e293b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1040,
    cy: 130,
    r: 180,
    fill: "#f97316",
    opacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 110,
    width: 1020,
    height: 540,
    rx: 30,
    fill: "#0b1220",
    stroke: "#f97316",
    strokeOpacity: 0.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 210,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 44,
    fontWeight: 800
  }, "DONATION ANALYTICS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 250,
    fill: "#cbd5e1",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24
  }, "Public totals, transparency dashboard, insights")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 330,
    width: 420,
    height: 210,
    rx: 18,
    fill: "#111827",
    stroke: "#475569"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 392,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 800
  }, "Total Donation")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 450,
    fill: "#f97316",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 40,
    fontWeight: 800
  }, "Tk 2,45,000+")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 330,
    width: 410,
    height: 210,
    rx: 18,
    fill: "#f97316",
    opacity: 0.9
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 390,
    fill: "#111827",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 800
  }, "Node.js  MongoDB")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 438,
    fill: "#111827",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "TypeScript  Vercel")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverDonationAnalytics);
export default __webpack_public_path__ + "static/media/cover-donation-analytics.a9e55bb436a91d0d2fe559ef9fd69b87.svg";
export { ForwardRef as ReactComponent };